module.exports = __webpack_public_path__ + "d7736ca140168a4b181bc9db0d320d7c.woff";